import React, {useState} from 'react';
import {useNavigate} from "react-router-dom";
import Service from "../../API/Service";
import MyInput from "../../components/UI/MyInput/MyInput";
import MyButton from "../../components/UI/MyButtons/MyButton";

const AdminAddPage = () => {
    const navigate = useNavigate();

    const [updatedData, setUpdatedData] = useState({
        name: "",
        surname: "",
        birthDate: "",
        login: "",
        phone: "",
    });

    const handleChange = (field, value) => {
        setUpdatedData(prev => ({
            ...prev,
            [field]: value
        }));
    };

    const create = async () => {
        try {
            await Service.createDep(updatedData, "admins");
            alert("Админ успешно создан!");
            navigate(-1);
        } catch (error) {
            alert("Ошибка при создании админа!");
        }
    };

    return (
        <div className={"constants__wrap"}>
            <h1>Admin</h1>
            <div className={"content"}>
                <MyInput
                    onChange={(value) => handleChange("name", value)}
                    info={{ name: "Name", value: updatedData.name }}
                    isDisabled={false}
                />
                <MyInput
                    onChange={(value) => handleChange("surname", value)}
                    info={{ name: "Surname", value: updatedData.surname }}
                    isDisabled={false}
                />
                <MyInput
                    onChange={(value) => handleChange("birthDate", value)}
                    info={{ name: "Date of Birth", value: updatedData.birthDate }}
                    isDisabled={false}
                />
                <MyInput
                    onChange={(value) => handleChange("login", value)}
                    info={{ name: "Email", value: updatedData.login }}
                    isDisabled={false}
                />
                <MyInput
                    onChange={(value) => handleChange("phone", value)}
                    info={{ name: "Phone Number", value: updatedData.phone }}
                    isDisabled={false}
                />
                <div className={"buttons"}>
                    <MyButton
                        content={"Back"}
                        isBlue={false}
                        onClick={() => navigate(-1)}
                    />
                    <MyButton
                        content={"Create new admin"}
                        isBlue={true}
                        onClick={create}
                    />
                </div>
            </div>
        </div>
    );
};

export default AdminAddPage;